import { Component, OnDestroy, OnInit } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import * as XLSX from "xlsx";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-all-education-session',
  templateUrl: './all-education-session.component.html',
  styleUrls: ['./all-education-session.component.scss']
})
export class AllEducationSessionComponent implements OnInit, OnDestroy  {
  private _destroyed$ = new Subject<void>();
  startDate: Date | undefined
  endDate: Date | undefined
  mData: any[] = []
  processedData = {};
  uniqueCentres: string[] = []
  tableData: any[] = []
  uniqueTecherData: any[] = []
  fileName = 'Education_Count_Report.xlsx';
  constructor(private readonly mFirestore: AngularFirestore) {
  }

  ngOnInit(): void {

  }

  search2() {
    if (this.startDate != null && this.endDate != null) {

    }
  }

  search() {
    if (this.startDate != null && this.endDate != null) {
      this.mFirestore.collection<any>('Educationtes')
          .valueChanges({idField: 'id'})
          .pipe(takeUntil(this._destroyed$))
          .subscribe(res => {
            // alert(res.length)
            this.      mData=res
            res.forEach(it => {

// Get unique Teachers  //STEP1
              const uniqueTeachers = [...new Set(this.mData.map(child => child.submittedBy))];
              console.log(uniqueTeachers);

              // Get unique centres
              this.uniqueCentres = [...new Set(this.mData.map(child => child.centreName))];
              console.log(this.uniqueCentres);
              let data2: any[] = []


              uniqueTeachers.forEach(t => {
                this.uniqueCentres.forEach(c => {

                  let obj = {
                    teacher: t,
                    centre: c,
                    count: this.mData.filter((child) => child.submittedBy == t && child.centreName == c).length

                  }
                  data2.push(obj)
                })

              })
              console.log(data2)
              // this.tableData = data2
              // console.log(this.tableData)

// Reformatting the data
              this.tableData = data2.reduce((acc, curr) => {
                const hospital = acc.find((item: any) => item.teacher === curr.teacher);
                if (hospital) {
                  hospital.centres.push({centre: curr.centre, count: curr.count});
                } else {
                  acc.push({
                    teacher: curr.teacher,
                    centres: [{centre: curr.centre, count: curr.count}]
                  });
                }
                return acc;
              }, []);
              console.log(this.tableData)
              // this.uniqueTecherData = this.uniqueTecherData.reduce((acc, curr) => {
              //   const hospital = acc.find((item: any) => item.ageGroup === curr.ageGroup);
              //   if (hospital) {
              //     hospital.centres.push({centre: curr.centre, count: curr.count});
              //   } else {
              //     acc.push({
              //       ageGroup: curr.ageGroup,
              //       centres: [{centre: curr.centre, count: curr.count}]
              //     });
              //   }
              //   return acc;
              // }, []);


            })
          })
    }
  }
  exportexcel() {

    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);



  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
